import React from 'react';
import reactStringReplace from 'react-string-replace';

/**
 * Converts a formatted input string into a shortcut key output string as an array of elements.
 * Characters surrounded by underscores will be underlined if accessKeyActive is true.
 * Otherwise, the underscores will be stripped.
 * Example format: "_G_raphic Templates" - Will cause the 'G' to be underlined.
 * @param {string} text Input string
 * @param {bool} accessKeyActive Controls whether output string will have access key underlined.
 */
// eslint-disable-next-line
export const generateShortcutText = (text, accessKeyActive, isInline) => {
  if (!text) {
    return null;
  }

  let newString = text;
  newString = reactStringReplace(newString, /(_._)/g, match => {
    if (accessKeyActive) {
      return <u key={match}>{match.replace(/_/g, '')}</u>;
    }
    return match.replace(/_/g, '');
  });
  return <div style={{ display: isInline ? 'inline' : 'block' }}>{newString}</div>;
};



// WEBPACK FOOTER //
// ./app/util/keyShortcutUtils.js